import React from 'react';
import { Menu } from 'antd';

import { DEFAULT_FILTER_LOGIC } from '../filterLogic';
import { useSubFilterMenuState } from '../hooks/useSubFilterMenuState';
import type { SubFilterMenuProps } from '../../ControlTower/types';
import SubFilterBody from './SubFilterBody';
import SubFilterFooter from './SubFilterFooter';
import SubFilterHeader from './SubFilterHeader';
import SubFilterSearch from './SubFilterSearch';
import '../Filters.css';

const SubFilterMenu: React.FC<SubFilterMenuProps> = ({
  loading = false,
  onDeletePreset,
  filterBy,
  hideBackArrow,
  secondaryFiltersDDL = [],
  secondaryFiltersSource = [],
  setSecondaryFiltersDDL,
  appliedFilters = [],
  filterLogic = DEFAULT_FILTER_LOGIC,
  onFilterLogicChange,
  selectedOptions,
  setSelectedOptions,
  filterTitle,
  handleAlertThresholdSelect,
  savedFilterKey,
  setSecondaryFiltersSource,
  handleSecondaryFilterSelect,
  handleApplyFilters,
  handleApplyPresetFilters,
  onResetGroup,
  setSecondFilterDisplay,
  setIsFilterOpen,
  dropdownMaxHeight,
  hiddenOptionIds,
  initialItemsCount,
  fetcherOverrides,
  alertFilterConfigOverride,
}) => {
  const {
    searchQuery,
    setSearchQuery,
    showSearchBar,
    isPaginated,
    isGroupedLocations,
    listToRender,
    menuStyle,
    paginatedListHeight,
    pg,
    handleCheckboxChange,
    handleReset,
    handleApply,
  } = useSubFilterMenuState({
    filterBy,
    loading,
    secondaryFiltersDDL,
    secondaryFiltersSource,
    setSecondaryFiltersDDL,
    setSecondaryFiltersSource,
    appliedFilters,
    setSelectedOptions,
    savedFilterKey,
    dropdownMaxHeight,
    hiddenOptionIds,
    initialItemsCount,
    fetcherOverrides,
    handleSecondaryFilterSelect,
    handleApplyFilters,
    onResetGroup,
    setSecondFilterDisplay,
    setIsFilterOpen,
  });

  const stopAll = (event: React.MouseEvent) => event.stopPropagation();

  return (
    <Menu style={menuStyle} selectable={false}>
      <Menu.ItemGroup
        title={
          <SubFilterHeader
            filterBy={filterBy}
            filterTitle={filterTitle}
            filterLogic={filterLogic}
            hideBackArrow={hideBackArrow}
            onFilterLogicChange={onFilterLogicChange}
            setSecondFilterDisplay={setSecondFilterDisplay}
            setIsFilterOpen={setIsFilterOpen}
          />
        }
      >
        {showSearchBar && (
          <SubFilterSearch
            searchQuery={searchQuery}
            isPaginated={isPaginated}
            setSearchQuery={setSearchQuery}
            setSearchDebounced={pg.setSearchDebounced}
            stopAll={stopAll}
          />
        )}

        <SubFilterBody
          filterBy={filterBy}
          loading={loading}
          isPaginated={isPaginated}
          isGroupedLocations={isGroupedLocations}
          listToRender={listToRender}
          secondaryFiltersSource={secondaryFiltersSource}
          selectedOptions={selectedOptions}
          appliedFilters={appliedFilters}
          searchQuery={searchQuery}
          hiddenOptionIds={hiddenOptionIds}
          paginatedListHeight={paginatedListHeight}
          pg={pg}
          stopAll={stopAll}
          setSelectedOptions={setSelectedOptions}
          handleAlertThresholdSelect={handleAlertThresholdSelect}
          handleCheckboxChange={handleCheckboxChange}
          handleApplyPresetFilters={handleApplyPresetFilters}
          onDeletePreset={onDeletePreset}
          alertFilterConfigOverride={alertFilterConfigOverride}
        />
      </Menu.ItemGroup>

      {filterBy !== 'saved_filters' && (
        <SubFilterFooter onReset={handleReset} onApply={handleApply} />
      )}
    </Menu>
  );
};

export default SubFilterMenu;
